<template>
  <div>
    <div class="card card-info">
      <div class="card-header with-border">
        <h3 class="card-title">
          Department Coordinator
        </h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class="card-body page-content container-fluid">
        <div class="row" style="margin-top: 10px">
          <div class="col-md-4">
            <label>Department</label>
            <select class="form-control" v-model="selectedDepartment" required="required" v-on:change="departmentChange()">
              <option value="0" disabled="disabled">--Select Department--</option>
              <option v-for="item in deparment" v-bind:value="item.School_DepartmentsID">{{item.Name}}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Program</label>
            <select class="form-control" v-model="selectedProgram" required="required">
              <option value="0">All</option>
              <option v-for="item in program" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label>Session</label>
            <select class="form-control" v-model="selectedSession" required="required">
              <option value="0">All</option>
              <option v-for="item in session" v-bind:value="item.SemesterID">{{item.Name}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-success float-right" style="width: 120px" v-on:click="ViewCourseOffered()" type="button">View</button>
        <button class="btn btn-danger" style="width: 120px" hidden>Cancel</button>
      </div>
    </div>
    <div class="card card-info" v-if="showgrid === 'show'">
      <!---->
      <div class="card-header with-border">
        <h3 class="card-title">Course Offered</h3>
      </div>
      <!-- /.box-header -->
      <!-- form start -->
      <div class="card-body page-content container-fluid">
        <div class="row" style="margin-top: 10px">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-bordered table-sm table-color" id="bs4">
                <thead class="bg-info">
                  <tr>
                    <th>Sr. No.</th>
                    <th>Course Name</th>
                    <th>Program</th>
                    <th>Session</th>
                    <th>Theory CH</th>
                    <th>Lab CH</th>
                    <th>Total CH</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, ind) in CourseOffered">
                    <td>{{ind+1}}</td>
                    <td>{{item.Name}}</td>
                    <td>{{item.ProgramName}}</td>
                    <td>{{item.SessionName}}</td>
                    <td>{{item.Theory}}</td>
                    <td>{{item.Lab}}</td>
                    <td>{{item.CreditHours}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        deparment: [],
        program: [],
        session: [],
        selectedDepartment: 0,
        selectedProgram: 0,
        selectedSession: 0,
        CourseOffered: [],
        showgrid: 'hide',
      }
    },
    updated: function () {
      $('#bs4').DataTable();
    },
    created: function () {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/PageloadCourseOffered')
          .then(function (response) {
            vm.session = response.data.sess;
            vm.deparment = response.data.lst;
            endReq();
          })
          .catch(function (error) {
          });
      },
      departmentChange() {
        var vm = this;
        startReq();
        axios.post('/api/DCApi/departmentChange?id=' + vm.selectedDepartment)
          .then(function (response) {
       
            vm.program = response.data.lst;
            endReq();
          })
      },
      ViewCourseOffered() {
        if (this.selectedDepartment == 0) {
          toastr.error("Please Select any Department", "Error!");
          return;
        }

        var vm = this;
        startReq();
        axios.post('/api/DCApi/loadCourseOffered?DepID=' + vm.selectedDepartment + '&ProgID=' + vm.selectedProgram + '&SessID=' + vm.selectedSession)
          .then(function (response) {
            vm.CourseOffered = response.data.lst;
            endReq();
            vm.showgrid = 'show';
            $('#bs4').DataTable().destroy();
          })
      }
    },
    
  })
</script>



// WEBPACK FOOTER //
// src/components/DC/courseOffered.vue